module.exports = __webpack_public_path__ + "img/upairy-card.77813f7d.png";